import React from "react";
export const BottomTimeLine = ({ date, comment }) => (React.createElement("div", { className: "bottom-time-line" },
    React.createElement("span", null, date),
    React.createElement("p", null, comment)));
